import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

type MastraErrorCardProps = {
    errorMessage: string;
    timestamp: number;
    onRetry?: () => void;
};

const MastraErrorCard = ({ errorMessage, timestamp, onRetry }: MastraErrorCardProps) => {
    const { t } = useTranslation();

    const formatTime = (ts: number) => {
        return new Date(ts).toLocaleTimeString();
    };

    return (
        <div className="my-4 rounded-lg border-2 border-red-500/50 bg-red-50 p-4 dark:border-red-500/30 dark:bg-red-950/20">
            <div className="flex items-start gap-3">
                <AlertCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400" />
                <div className="flex-1">
                    <h3 className="text-base font-semibold text-red-900 dark:text-red-100">
                        {t("mastra.error.title", "AI having a bad day 😞")}
                    </h3>
                    <div className="mt-2 space-y-2">
                        <p className="text-sm text-red-800 dark:text-red-200">
                            <span className="font-medium">{t("mastra.error.label", "ERROR:")}</span>{" "}
                            {errorMessage}
                        </p>
                        <p className="text-xs text-red-700 dark:text-red-300">
                            {t("mastra.error.time", "Time:")} {formatTime(timestamp)}
                        </p>
                    </div>
                    {onRetry && (
                        <div className="mt-4">
                            <Button
                                onClick={onRetry}
                                variant="destructive"
                                size="sm"
                                className="bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-800"
                            >
                                {t("mastra.error.retry", "RETRY")}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MastraErrorCard;

